import React, { useEffect, useMemo, useState } from "react";
import { popupConfirmDelete } from "../../../utils/Popups";
import { TrimText } from "../../common/TrimText";
import "jspdf-autotable";
import CreateStudyPathModuleModel from "./CreateStudyPathModuleModel";
import { Link, useParams } from "react-router-dom";
import DataTableComponentFrontPagination from "../../common/DataTableComponentFrontPagination";
import PermissionsGate from "../../../utils/permissionGate";

const TableStudyPath = ({
  tableData,
  setTableData,
  tableData1,
  setTableData1,
  formik,
  loading,
  label,
  name,
  modelID = "addModules2",
  module_type,
  ArrayFields,
  versionData=[],
  setTotalCredits
}) => {
  const {type} = useParams()
  const [searchAssigned, setSearchAssigned] = useState("");
  
  const confirmDelete = (row) => {
    popupConfirmDelete((result) => {
      if (result.isConfirmed) {
        addOrDeleteProgramme(row, "delete");
      }
    })
  };
  
useEffect(() => {
  const total = tableData?.reduce((total, item) => {
    return total + (item?.credits || 0);
  }, 0);
  
  setTotalCredits(prevState => ({...prevState,[name] : total}));
}, [tableData]);
  const totalCredits = () => {
    return tableData?.reduce((total, item) => {
      return total + (item?.credits || 0);
    }, 0);
  };
  const addOrDeleteProgramme = (row, type) => {
    let assigntemp = [...tableData];
    let availtemp = [...tableData1];
    if (type === "add") {
      assigntemp.push(row);
    } else if (type === "delete") {
      assigntemp = assigntemp.filter((data) => data.Id !== row.Id);
    }
    setTableData([...assigntemp]);
    formik.setFieldValue(ArrayFields, assigntemp?.map((item) => item.Id) || [])
    setTableData1([...availtemp]);
  };

  const columns = useMemo(() => [
    {
      name: "Name",
      selector: "name",
      sortable: true,
      cell: (row) => (
        <Link
          className="as-text-blue curser feature-name"
          to={`/program-management-center/modules/module/open/${row.Id}`}
          title={row.name}
        >
          <span className="textLimit100">{row.name}</span>
        </Link>
      ),
    
    },
    {
      name: "Code",
      selector: "Code",
      sortable: true,
      cell: (row) => (
        <div className="ticket-id">
          {row.Code ? (
            <span title={row.Code} className="overflow-ellipsis2 as-text-blue">
              {TrimText(row.Code, 25)}
            </span>
          ) : (
            "-"
          )}
        </div>
      ),
    },

    {
      name: "Duration (Weeks)",
      selector: "Duration",
      sortable: true,
      cell: (row) => (
        <div className="ticket-id">
          {row.Duration ? (
            <span
              title={row.Duration}
              className="overflow-ellipsis2 as-text-blue"
            >
              {TrimText(row.Duration, 25)}
            </span>
          ) : (
            "-"
          )}
        </div>
      ),
    },
    {
      name: "Credits",
      selector: "credits",
      sortable: true,
      cell: (row) =>
        row.credits ? <div title={row.credits}>{row.credits}</div> : "-",
    },
    {
      name: "Actions",
      selector: "",
      cell: (row) => (
        <div className="assessment-08 btn-dropdown-grp">
          <div className="as-buttons">
            <Link
              to={`/program-management-center/modules/module/open/${row.Id}`}
              className="btn btn-primary rounded-circle"
              title="Open"
            >
              <i className="fal fa-folder-open"></i>
            </Link>
            {
              type == "open" ? (

                <PermissionsGate scopes={['pmcstudypathmoduleedit']} RenderError={() => (
                  <button
                    className="btn btn-danger rounded-circle"
                    title="Delete"
                    disabled
                  >
                    <i className="fal fa-trash-alt"></i>
                  </button>
                )}>
                  <button
                    title="Delete"
                    type="button"
                    className="btn btn-danger rounded-circle"
                    onClick={() => confirmDelete(row)}>
                    <i className="fal fa-trash-alt"></i>
                  </button>
                </PermissionsGate>
              ) : (
                <button
                  title="Delete"
                  type="button"
                  className="btn btn-danger rounded-circle"
                  onClick={() => confirmDelete(row)}>
                  <i className="fal fa-trash-alt"></i>
                </button>
              )
            }
          </div>
        </div>
      ),
    },
  ]);

  const exportDataAssignedStd = () => {
    let data = dataToRenderAssignedStd();
    const header = ["Name", "Code", "Duration (Weeks)", "Credits"];
    
    data = data?.map((row) => {
      return ({
        ...row,
        "Name": row.name ? row.name : "-",
        "Code": row.Code ? row.Code : "-",
        "Duration (Weeks)": row.Duration ? row.Duration : "-",
        "Credits": row.credits ? row.credits : "-",
      })
    });
    const pdfData = data.map((row) => {
      return [row["Name"], row["Code"],row["Duration (Weeks)"], row["Credits"]];
    });    
    return {
        header,
        data,
        pdfData,
        columnStyles: {}
    }
  };

  const dataToRenderAssignedStd = () => {
    let updatedData = [];
    let allData = tableData?.map(
      (d,i) => {
        if(d.credits == null){
          d.credits = 0;
        }
        if(d.Duration == null){
          d.Duration = 0;
        }
        return d
      }
    );
    if (searchAssigned.length) {
      let tempStudent = allData.filter((item) => {
        let includes = item.name?.toLowerCase().toString().includes(searchAssigned.toLowerCase());
        if (includes) {
          return includes;
        } else return null;
      });

      let data = [...tempStudent];
      let unique = [...new Set(data)];
      updatedData = unique;
    } else {
      updatedData = allData;
    }

    if (searchAssigned?.length) {
      return updatedData;
    } else {
      return tableData;
    }
  };
  return (
    <>
      <div className="col-md-12">
        <div className="new-card-header">
          <div className="card-header">{label}</div>
        </div>
      </div>
      <div className="col-md-3 col-lg-3">
        <div className="form-group-blk mb-3">
          <label>Credits Required* </label>
          <input
            type="number"
            className={
              "form-control" +
              (formik.errors[name] && formik.touched[name] ? " is-invalid" : "") +
              (versionData?.lock_version_settings ? " block-action" : "")
            }
            placeholder="Enter required credit amount"
            name={name}
            id={name}
            title="Credits Required"
            value={formik.values[name]}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            disabled={versionData?.lock_version_settings}
          />
        </div>
      </div>
      <div className="col-md-4 col-lg-4">
        <div className="form-group-blk mb-3">
          <label className="mb-3">Total Credits</label>
          <br />
          <span className="mt-1">{totalCredits()}</span>
        </div>
      </div>
      <div className="col-12">
        <div className="my-tickets-info-list Tickets-main-wrap tickets-new-custom">
          <div className="custom-table-div filter-search-icon card-table-custom">
            <div className="search-filter-div">
            </div>
            <DataTableComponentFrontPagination
                isInsidePopUp
                data={dataToRenderAssignedStd()}
                columns={columns}
                loading={loading}
                search={searchAssigned}
                setSearch={setSearchAssigned}
                exportData={exportDataAssignedStd}
                exportFileName="Assign Modules"
                tableButton={[
                  <PermissionsGate scopes={['pmcstudypathmoduleedit']} RenderError={() => (
                    <button
                        className="btn btn-primary"
                        title="Open"
                        disabled
                    >
                        <i className="fal fa-plus"></i>Add Modules
                    </button>
                )}>

                  <button className={`btn btn-primary ${versionData?.lock_version_settings ? "block-action" : ""}`} title="Assign Students" type="button" data-toggle="modal" data-target={`#${modelID}`} disabled={versionData?.lock_version_settings ? true : (formik.values.AssessmentType == 9 && !formik.values.override_mark_ass_id)}>
                    <i className="fal fa-plus"></i>Add Modules
                  </button>
                  </PermissionsGate>
                ]}
              />
          </div>
        </div>
      </div>
      <div
        className="topic-add-modal modal fade"
        id={modelID}
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered available-assessment-modal"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header modal-header-custom">
              <h5 className="modal-title">
                <i className="fal fa-plus"></i> Add Modules
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <CreateStudyPathModuleModel
              addProgramme={addOrDeleteProgramme}
              setTableData1={setTableData1}
              tableData1={[...tableData1]}
              tableData={tableData}
              module_type={module_type}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default TableStudyPath;
